import { useEffect, useState } from "react";
import "./Intro.css";
import Mask from "../images/Mask.png";

const Intro = ({ children }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const hasSeenIntro = sessionStorage.getItem("seenIntro");

    if (hasSeenIntro) {
      setLoading(false);
      return;
    }

    const timer = setTimeout(() => {
      sessionStorage.setItem("seenIntro","true");
      setLoading(false);
    }, 7000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading ? (
        <div className="intro">
          <img src={Mask} alt="mask" className="mask" />

          <p className="quote">

            <span className="line1">
              <span className="nonkw">"In times of </span>
              <span className="kw">crisis</span>
              <span className="nonkw">, the </span>
              <span className="kw">wise</span>
              <span className="nonkw"> </span>
              <span className="kw">build</span>
              <span className="nonkw"> </span>
              <span className="kw">bridges</span>
              <span className="nonkw">,</span>
            </span>

            <br />

            <span className="line2">
              <span className="nonkw">while the </span>
              <span className="kw">foolish</span>
              <span className="nonkw"> </span>
              <span className="kw">build</span>
              <span className="nonkw"> </span>
              <span className="kw">barriers</span>
              <span className="nonkw">".</span>
            </span>

            <span className="author">Black Panther</span>

          </p>
        </div>
      ) : (
        <div className="fade-in">
            {children}
        </div>
      )}
    </>
  );
};

export default Intro;